export default "__VITE_PUBLIC_ASSET__598730ab__"